import { render, staticRenderFns } from "./listaentradas.vue?vue&type=template&id=64591e42&scoped=true&"
import script from "./listaentradas.vue?vue&type=script&lang=js&"
export * from "./listaentradas.vue?vue&type=script&lang=js&"
import style0 from "./listaentradas.vue?vue&type=style&index=0&id=64591e42&scoped=true&lang=css&"
import style1 from "./listaentradas.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64591e42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer,VFlex,VLayout})
